// extracted by mini-css-extract-plugin
export var legendIndicator = "_du-1";
export var legendRight = "_du-0";